"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Type of all possible regions. Currently we only support region of Table
 */
var RegionType;
(function (RegionType) {
    /**
     * Region splitted by Table
     */
    RegionType[RegionType["Table"] = 0] = "Table";
})(RegionType = exports.RegionType || (exports.RegionType = {}));
//# sourceMappingURL=RegionType.js.map